import { useContext, useState, memo, createContext, useMemo } from 'react';
import { DROPS_DEFAULT_TAB, DROPS_STATUS_TAB_ID, DropsFilter, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { StringQueryParam } from 'root/src/client/v2/queryParams/helpers/params.helper';
import { useQueryParam } from 'use-query-params';
export const DropEventListFiltersContext = createContext(null);
export function useDropEventListFiltersContext() {
    const context = useContext(DropEventListFiltersContext);
    if (!context) {
        throw new Error('useDropEventListFiltersContext must be used within DropEventListFiltersContext');
    }
    return context;
}
export const DropEventListFiltersContextProvider = memo((props) => {
    const [filter, setFilter] = useState(DropsFilter.All);
    const [tab, onTabChange] = useQueryParam(DROPS_STATUS_TAB_ID, StringQueryParam({ default: DROPS_DEFAULT_TAB }));
    const onFilterChange = (newFilter) => {
        setFilter(newFilter);
    };
    const contextValue = useMemo(() => {
        return {
            tab,
            filter,
            onTabChange,
            onFilterChange,
        };
    }, [tab, filter, onTabChange, onFilterChange]);
    return (<DropEventListFiltersContext.Provider value={contextValue}>
			{props.children}
		</DropEventListFiltersContext.Provider>);
});
